
import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  DealIndent: (param) => {   // 支付管理-交易订单列表
    return GET('/merchant/orderMain/querySellerOrderPage', param)
  },
  OrderListExport: (param, rsType) => {   // 支付管理-交易订单列表-列表导出
    return GETPDF('/merchant/orderMain/querySellerOrderExport', param, rsType);
  },
  ViewProvision: (param) => {   // 支付管理-交易订单列表-查看发放清单
    return GET('/merchant/orderDetail/orderPaymentDetail', param)
  },
  OrderStatus: (param) => {   // 支付管理-交易订单列表-订单状态
    return GET('/merchant/orderMain/queryStayOrder', param)
  },
  ModifyOrderStatus: (param) => {   // 支付管理-交易订单列表-修改订单状态
    return POST('/merchant/orderMain/disOrderPayment', param)
  },
  EnquiryAccount: (param) => {   // 支付管理-新增订单-查询账户
    return GET('/merchant/account/queryAccountByServiceAndMerchantId', param)
  },
  InquireMission: (param) => {   // 支付管理-新增订单-查询任务
    return GET('/merchant/taskPublish/queryTaskPublishByMerchantId', param)
  },
  publishByMerchant: (param) => {   // 首衡支付管理-新增订单-查询任务
    return GET('/merchant/taskPublish/queryNewTaskPublishByMerchantId', param)
  },
  UploadPayment: (param) => {   // 支付管理-新增订单-上传支付清单
    return POST("/merchant/orderMain/insFeeSend", param)
  },
  UploadPaymentPrivate: (param) => {   // 支付管理-新增订单-上传支付清单
    return POST("/merchant/orderMain/insMerchantFeeSend", param)
  },
  SubmitOrder: (param) => {   // 支付管理-新增订单-提交订单
    return POST("/merchant/orderMain/saveData", param)
  },
  SubmitOrderPrivate: (param) => {   // 支付管理-新增订单-提交订单
    return POST("/merchant/orderMain/saveMerchantData", param)
  },
  PaymentFlow: (param) => {   // 支付管理-支付流水列表
    return GET('/merchant/accountPaymentDetail/querySellerBalanceRecord', param)
  },
  ReceiptImgShow: (param) => { // 下载电子回单
    return GET("/merchant/accountPaymentDetail/downReceipt", param);
  },
  PaymentFlowExport: (param, rsType) => {   // 支付管理-支付流水列表-导出
    return GETPDF('/merchant/accountPaymentDetail/querySellerBalanceRecordExport', param, rsType);
  },
  SuspendOrder: (param) => {   // 支付管理-挂起订单列表
    return GET('/merchant/orderDetail/queryStayOrder', param)
  },
  SuspendOrderExport: (param, rsType) => {   // 支付管理-挂起订单列表-列表导出
    return GETPDF('/merchant/orderDetail/queryStayOrderExport', param, rsType);
  },
  downloadReceipt: (param) => {   // 电子回单批量下载按条件导出
    return GET('/merchant/accountPaymentDetail/merchent/downloadReceipt', param);
  },
  thisDownloadReceipt: (param) => {   // 电子回单批量下载按订单id导出
    return GET('/merchant/accountPaymentDetail/backstage/thisDownloadReceipt', param);
  },
  personalGrant: (param) => {   // 商户端单笔发放信息查询
    return GET('/merchant/accountPaymentDetail/personalGrant', param);
  },
  singlePayment: (param) => {   // 商户端单笔支付-对私
    return POST("/merchant/orderMain/singlePayment", param)
  },
  singlePaymentPrivate: (param) => {   // 商户端单笔支付-对公
    return POST("/merchant/orderMain/singleMerchantPayment", param)
  },
  singlePaymentCheck: (param) => {   // 单笔支付二次确认 -- 对私
    return POST("/merchant/orderMain/singlePaymentCheck", param)
  },
  singlePaymentCheckPrivate: (param,) => {   // 单笔支付二次确认 -- 对公
    return POST("/merchant/orderMain/singleMerchantPaymentCheck", param)
  },
  getSettingInfo: (param) => { // 认证管理，获取认证最大年龄预警
    return GET('/merchant/dataDict/getSettingInfo', param);
  },
  // 个税统计查看详情
  taxCensusDetails: (param) => {   // 个税统计查看详情
    return GET("/merchant/taxDetail/taxCensusDetails", param);
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/payment-regulate.js